import { WINDOW } from '@app/config';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/analytics';

firebase.initializeApp({
    apiKey: "AIzaSyBUOzlL4VpWFQix5t5KfZ75R7T2nVIZ1Zk",
    authDomain: "skool-spectry.firebaseapp.com",
    projectId: "skool-spectry",
    storageBucket: "skool-spectry.appspot.com",
    messagingSenderId: "304941712970",
    appId: "1:304941712970:web:2d956f518294f34f0808b3",
    measurementId: "G-YSNDRKQ8ZF"
});
export const functions = firebase.app().functions('europe-west1');

WINDOW.firebase = firebase;
export { firebase };